<template>
  <div>
      <!-- Display assets based on the selected month and theme -->
      <v-container fluid>
        <div v-for="(newslettersByType, type) in groupedNewsletters" :key="type">
          <v-row>
            <v-col cols="12">
              <h2>{{ type }} Newsletters</h2> <!-- Optional: Display type as a header -->
            </v-col>
          </v-row>
          <!-- Loop through the newsletters for the current type and render them in columns -->
          <v-row>
            <v-col v-for="(newsletter, index) in newslettersByType" :key="index" cols="12" md="4">
              <v-card @click="openDesign(newsletter.url)" class="mx-auto elevation-4" outlined>
                <v-img :src="newsletter.thumbnail" cover></v-img>
                <v-divider></v-divider>
                <v-card-title class="d-flex justify-space-between title-truncate">
                  <span class="ellipsis">{{ newsletter.title }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-subtitle>{{ newsletter.subtitle }}</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <br />
          <v-divider></v-divider>
        </div>
      </v-container>
  </div>
</template>

<script>
  import content from '@/assets/newsletters.js'  // Import the content data

  export default {
      name: 'NewsLetters',
      data: () => ({
          content, 
          previousMonth: '',
          currentMonth: '',
          targetType: '',
          region: '',
      }),
      mounted() {
        this.scrollToTargetGroup();
        this.targetType = this.$route.query.targetType || '';
        this.previousMonth = this.$route.query.previousMonth || '';
        this.currentMonth = this.$route.query.currentMonth || '';
        this.region = this.$route.query.region || '';
      },
      computed: {
        newsletters() {
          return this.content.newsletters;
        },
         // Get the selected region from query parameters
        selectedRegion() {
          return this.$route.query.region || ''; // Default to an empty string if no region is passed
        },

        // Group newsletters by type and filter by region
        groupedNewsletters() {
          const grouped = {};
          
          // First, filter the newsletters based on the selected region
          const filteredNewsletters = this.newsletters.filter((newsletter) => {
            // Filter by region if selectedRegion is set, otherwise include all
            return this.selectedRegion ? newsletter.region === this.selectedRegion : true;
          });

          // Then group the filtered newsletters by type
          filteredNewsletters.forEach((newsletter) => {
            if (!grouped[newsletter.type]) {
              grouped[newsletter.type] = [];
            }
            grouped[newsletter.type].push(newsletter);
          });

          return grouped;
        }
      },
      methods: {
        // Open the design in a new tab when a card is clicked
        openDesign(url) {
          window.open(url, '_blank');
        },
        scrollToTargetGroup() {
          if (this.targetGroupType) {
            const targetElement = this.$refs[this.targetGroupType];
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' });
            }
          }
        },
      },
  }
</script>

<style scoped>

  .title-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis {
    display: block;
    width: 100%;         /* Make sure the width is limited by its container */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
 
  .v-card-title {
    padding: 16px 16px 8px;  /* Padding around the title */
  }

  .v-card-subtitle {
    padding: 4px 16px 4px;  /* Padding around the subtitle */
  }
</style>